module.exports = __webpack_public_path__ + "static/media/Deloitte.b5165331.png";